export default __webpack_public_path__ + "static/adaptive-6c3b1e8ed80fc2322bda4212f86f25e1.png";